import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, routeForRole } from "@/lib/auth";
import { FullScreenLoader } from "@/components/States";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  // Admins may view any authenticated screen; otherwise enforce the required role.
  if (role && user.role !== role && user.role !== "admin") {
    return <Navigate to={routeForRole(user.role)} replace />;
  }
  return children;
}
